<template>
  <div class="aboutus">
    <!-- 头部 -->
    <header class="aboutus-header">
      <div class="contation">
        <!-- logo -->
       <div class="logo">
          <img
          src="../../assets/logo.png"
          alt=""
        />
        </div>
         
        <ul class="nav">
          <li>
            <a href="#/home">首页</a>
          </li>
          <li>
            <a href="#/counseling">咨询服务</a>
          </li>
          <li class="active">
            <a style="color: #fff" href="#/AboutUs">关于我们</a>
          </li>
        </ul>

        <div class="moblie">
          <a href="">客服热线: 010-8274334</a>
        </div>
        <div class="consult">
          <p class="service-text">关于我们</p>
          <p class="null"></p>
          <p class="service-as">About Us</p>
        </div>
      </div>
      <div class="company">
        <div class="left">
         
            <img src="../../assets/Corporate.png" alt="">
          
          <h1>公司简介</h1>
          <p class="text">
            国体智慧运动(北京)科技有限公司办公室地址位于中国的首都、正式、文化中心北京、北京
            北京失通州区观音腌安街道1号院一号楼2单元22层19356，于2021年0727日在北京市通州区市场监督管理局注册成立，注册资本为100（万元），在公司发展壮大的一年里，我们始终为客户提供好的产品和技术支持，健全的售后服务，我公司主要经营技术推广，技术开发技术咨询，技术转让，技术服务
          </p>
        </div>
        <div class="rgiht">
          <img
            src="../../assets/编组 4.png"
            alt=""
          />
        </div>
      </div>
    </header>
    <div class="main">
      <div class="culture">
        <div class="left">
        
            <img class="imags" src="../../assets/Company.png" alt="">
       
          <h1>企业文化</h1>

          <p class="text">在快速变化的市场中，坚守责任与初心</p>
          <img
            src="../../assets/位图.png"
            alt=""
          />
        </div>
        <div class="right">
          <h1>愿景</h1>
          <p>
            致力于用科技的力量创造更好美好的未来，让智慧与专业创造的更大价值，助推行业的快速发展及进步
          </p>
        </div>
      </div>
    </div>
    <Floot></Floot>
  </div>
</template>

<script>
import Floot from '@/components/floot'
export default {
  components: {
    Floot,
  },
}
</script>

<style>
.aboutus{
  position: relative;
}
.aboutus-header {
  height: 850px;
  width: 100%;
  background-image: url('../../assets/bj3.png');
  background-size: cover;
}
.company {
  position:absolute;
  top: 500px;
 
  display: flex;
  justify-content: space-around;
  padding-left: 320px;
  width: 1500px;
  height: 394px;

  background: #fff;
}

.company .left {
  margin-top: 50px;
  position: relative;
  width: 700px;
}
.company .left .yu {
  width: 486px;
  height: 63px;

  position: absolute;
  top: -45px;
  opacity: 0.4;
 
  font-size: 36px;
}
.company .left  img {
  position: absolute;
  top: 0px;

}
.company .left h1 {
  font-weight: normal;
  font-size: 40px;
}
.company .rgiht {
  margin-top: 30px;



}
.company .left .text {
  font-size: 16px;
  color: #5C5D66;
}
.main {
  position: relative;
  width: 100%;
  height: 750px;
  background: #eff2f4;
}
.main .culture {
  width: 1200px;
  padding-top: 30px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.main .culture .left {
  height: 600px;
  padding-top: 0px;
  width: 600px;
  /* background: red; */
}
.main .culture .left .imags {
  position: absolute;
  top: 30px;
  width: 528px;
  height: 63px;
}
.main .culture .left h1 {
  font-weight: normal;
  font-size: 40px;

  color: #2E2F33;
 
}
.main .culture .left .text {
  font-size: 16px;
  color: #5C5D66;
}

.main .culture .right {
  position: absolute;
  right: 500px;
  top: 230px;
  width: 588px;
  height: 334px;
  background-image: linear-gradient(#44b8e6, #31acf2, #18a1f8);
}
.main .culture .right h1 {
  font-weight: normal;
  font-size: 24px;
  padding-left: 127px;
  padding-top: 106px;
  color: #fff;
}
.main .culture .right p {
  font-size: 16px;
  padding-left: 127px;
  padding-right: 160px;
  color: #eff2f4;
}
</style>
